import { createStore, applyMiddleware, compose } from "redux";
import createHistory from "history/createBrowserHistory";
import { createLogger } from "redux-logger";
import { Iterable } from "immutable";
import thunk from "redux-thunk";
import { routerMiddleware } from "react-router-redux";

import reducers from "./reducers";
import syncSearchStateWithUrl from "./middleware/syncSearchStateWithUrl";

export const history = createHistory();
const router = routerMiddleware(history);

const skipLoggingActionTypes = [
  "@@redux-form/REGISTER_FIELD",
  "@@redux-form/UNREGISTER_FIELD"
];

const stateTransformer = state => {
  if (!(state instanceof Object)) {
    return state;
  }

  const newState = {};

  Object.keys(state).forEach(key => {
    if (Iterable.isIterable(state[key])) {
      newState[key] = state[key].toJS();
    } else {
      newState[key] = stateTransformer(state[key]);
    }
  });

  return newState;
};

const logger = createLogger({
  diff: true,
  collapsed: true,
  predicate: (getState, action) =>
    skipLoggingActionTypes.indexOf(action.type) === -1,
  stateTransformer
});

let store = null;

// eslint-disable-next-line
const composeEnhancer = global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ // eslint-disable-line
  : compose;

export default function create() {
  if (!store) {
    const storeCreator =
      process.env.NODE_ENV === "production" ||
      process.env.NODE_ENV === "staging"
        ? applyMiddleware(router, thunk, syncSearchStateWithUrl)
        : composeEnhancer(
            applyMiddleware(router, thunk, syncSearchStateWithUrl, logger)
          );

    store = createStore(reducers, storeCreator);
  }

  return store;
}



// WEBPACK FOOTER //
// ./app/createStore.js